import { render } from "./ResultList.vue?vue&type=template&id=c89c9484&scoped=true"
import script from "./ResultList.vue?vue&type=script&lang=js"
export * from "./ResultList.vue?vue&type=script&lang=js"

import "./ResultList.vue?vue&type=style&index=0&id=c89c9484&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c89c9484"]])

export default __exports__